import Breadcrumb from "../Component/Breadcrumb";
const SchoolPrayer = () => {
  return (
    <>
      <Breadcrumb
        breadtitle="School Prayer"
        breadmid="About"
        breadend="School Prayer"
      />
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="prayer-img">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/prayer.jpg"
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="prayer_section">
                <h2 className="maintitle">School Prayer</h2>
                <h5>
                  Our Father, who art in Heaven, hallowed be Thy Name.
                  <br />
                  Thy Kingdom come, Thy will be done, on earth, as it is in
                  Heaven.
                  <br />
                  Give us this day our daily bread and forgive us our sins,
                  <br />
                  as we forgive those who sin against us,
                  <br />
                  an lead us not into temptation, but deliver us from evil.
                  <br />
                  Amen!
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SchoolPrayer;
